import emailjs from '@emailjs/browser';

// Configuration EmailJS
const EMAIL_CONFIG = {
  serviceId: 'service_r0xppci',  // Tu devras remplacer par ton service ID
  templateId: 'template_3c0eymj',  // Tu devras remplacer par ton template ID
  publicKey: '9ToD8QBBsPzcBStow'   // Tu devras remplacer par ta clé publique
};

// Initialiser EmailJS
emailjs.init(EMAIL_CONFIG.publicKey);

export const sendSimulationEmail = async (formData) => {
  try {
    // Vérifications de base
    console.log('=== DEBUT DEBUG EMAILJS ===');
    console.log('1. Configuration EmailJS:', {
      serviceId: EMAIL_CONFIG.serviceId,
      templateId: EMAIL_CONFIG.templateId,
      publicKey: EMAIL_CONFIG.publicKey.substring(0, 5) + '...' // Masquer la clé
    });

    // Vérifier que emailjs est bien chargé
    console.log('2. EmailJS library:', typeof emailjs, emailjs);
    
    if (!emailjs) {
      throw new Error('EmailJS library not loaded');
    }

    // Test de données simples d'abord
    const templateParams = {
      to_name: 'Yassine',
      from_name: formData.name || 'Test User',
      from_email: formData.email || 'test@test.com',
      message: `
🔸 Nom: ${formData.name}
🔸 Email: ${formData.email}  
🔸 Téléphone: ${formData.phone}
🔸 Adresse: ${formData.address}
🔸 Service: ${formData.serviceType}
🔸 Type énergie: ${formData.energyType}
🔸 Consommation: ${formData.consumption}
🔸 Panneaux: ${formData.solarPanels}
🔸 Batterie: ${formData.battery}
🔸 Infos supplémentaires: ${formData.request}
🔸 Date: ${new Date().toLocaleString('fr-FR')}
      `
    };

    console.log('3. Template params:', templateParams);

    console.log('4. Tentative d\'envoi...');
    
    const result = await emailjs.send(
      EMAIL_CONFIG.serviceId,
      EMAIL_CONFIG.templateId,
      templateParams
    );

    console.log('5. Résultat brut:', result);
    console.log('6. Status:', result?.status);
    console.log('7. Text:', result?.text);

    if (result && result.status === 200) {
      console.log('✅ SUCCÈS: Email envoyé!');
      return { success: true, message: 'Email envoyé avec succès!' };
    } else {
      console.log('❌ ÉCHEC: Status différent de 200');
      throw new Error(`Status: ${result?.status}, Text: ${result?.text}`);
    }
    
  } catch (error) {
    console.error('❌ ERREUR DÉTAILLÉE:', {
      name: error.name,
      message: error.message,
      stack: error.stack,
      fullError: error
    });
    
    return { 
      success: false, 
      message: error.message || 'Erreur inconnue',
      error: error 
    };
  } finally {
    console.log('=== FIN DEBUG EMAILJS ===');
  }
};

// Fonction de fallback qui utilise mailto comme solution de secours
export const sendEmailFallback = (formData) => {
  const subject = encodeURIComponent('Nouvelle demande de simulation énergétique');
  const body = encodeURIComponent(`
Nouvelle demande de simulation reçue :

📋 INFORMATIONS CLIENT
• Nom : ${formData.name}
• Email : ${formData.email}
• Téléphone : ${formData.phone}
• Adresse : ${formData.address}

🔋 DÉTAILS DE LA DEMANDE
• Type de service : ${formData.serviceType}
• Type d'énergie : ${formData.energyType}
• Consommation annuelle : ${formData.consumption}
• Nombre de panneaux solaires : ${formData.solarPanels}
• Batterie souhaitée : ${formData.battery}

💬 INFORMATIONS SUPPLÉMENTAIRES
${formData.request}

📅 Date de soumission : ${new Date().toLocaleString('fr-FR', {
    timeZone: 'Europe/Brussels'
  })}
  `);
  
  const mailtoLink = `mailto:yassinemanouach7@gmail.com?subject=${subject}&body=${body}`;
  window.open(mailtoLink, '_blank');
  
  return { 
    success: true, 
    message: 'Votre client email s\'ouvrira pour envoyer la demande. Si cela ne fonctionne pas, contactez-nous directement.' 
  };
};